import axios from "axios";

const callaxios = axios.create({
    //baseURL: "https://sandbox.surepass.io/api/v1/",
    baseURL: "https://kyc-api.surepass.io/api/v1/",
	headers:{
        "content-type" : "application/json",
        'Access-Control-Allow-Origin' : "https://kyc-api.surepass.io",
        'Access-Control-Allow-Methods' :  "POST, GET, OPTIONS, PUT, DELETE",
        'Access-Control-Allow-Headers' :  "Content-Type, X-Auth-Token, Origin, Authorization, UserId"
    }
});



export default callaxios
// configure headers
callaxios.interceptors.request.use(
    config =>
  {
    config.headers['Authorization'] = 'Bearer ' + "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTY2MjQ1OTI1MCwianRpIjoiNGNkNjJkZGItMzllZC00YjVkLWE1ZDQtOWU2NjdhYTJiM2RjIiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2LnN5bnRyaW5vQHN1cmVwYXNzLmlvIiwibmJmIjoxNjYyNDU5MjUwLCJleHAiOjE5Nzc4MTkyNTAsInVzZXJfY2xhaW1zIjp7InNjb3BlcyI6WyJ3YWxsZXQiXX19.pW65XNfucAUnWBIlHNde45fOEqDMHdBvO8ystA9YCDA";
    return config;
  },
  (error) => {
    return Promise.reject(error)
  }
)